import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { getPaidCountRoute } from '../api/constant';
import { employerPaidCount } from '../constants';

type useGetEmployerPaidCountProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
    id: number | boolean | null
    isEnterprise: number | boolean
};

export const useGetEmployerPaidCount = ({
    setAlertText = () => { },
    id,
    isEnterprise,
}: useGetEmployerPaidCountProps) => {
    const { data: paidCount, isFetching: isLoadingPaidCount } =

        useQuery({
            queryKey: [employerPaidCount, id],
            queryFn: () =>
                axiosInstance
                    .get(getPaidCountRoute + '?company_id=' + String(id) + '&is_enterprise=' +String(isEnterprise))
                    .then((res) => res.data),
            enabled: Boolean(id),
            onSuccess: (data) => {
                if (data.status !== 201) {
                    setAlertText(data.message);
                }
            },
            onError: () => {
                setAlertText(errorMessage);
            },
            refetchOnWindowFocus: false,
        });

    return {
        paidCount,
        isLoadingPaidCount,
    };
};
